
import { Col, Row, Container } from "react-bootstrap";
import BreadcrumbLayout from "../../component/Breadcrumb";
import { useTranslation } from "react-i18next";

import { FilePdfOutlined, DownloadOutlined } from "@ant-design/icons";
import { useEffect, useState, useMemo } from "react";
import { PageContentService } from "../../Services/PageContentService";
import Loader from "../../global/Loader";
import Swal from "sweetalert2";
import { Empty } from "antd";
import AboutSidebar from "./AboutSideBar";
// import Animation from "../../assets/images/Animation.gif";


export default function AnnualReport() {
  const { t, i18n } = useTranslation();

  const menuData =
    t("menu", {
      returnObjects: true,
    }) || {};

  const pageContentService = useMemo(() => new PageContentService(), []);
  const [tblDataDownloadPdf, setTblDataDownloadPdf] = useState([]);
   const [loadingTblData, setLoadingTblData] = useState(false);

  const [lang, setLang] = useState(localStorage.getItem('language') === "en" ? 2 : 1);
  useEffect(() => {
    setLang(localStorage.getItem('language') === "en" ? 2 : 1);
  }, [i18n.language]);

  const [pageLoading, setPageLoading] = useState(false);
  const viewDoc = async (doc) => {
    try {
      setPageLoading(true);
      if (doc.DocUniqueId !== null) {
        const res = await pageContentService.ViewDocument(doc.DocUniqueId);
        if (res.status === 200) {
          const fileBlob = new Blob([res.data], { type: doc.DocMimeType });
          let dataUrl = window.URL.createObjectURL(fileBlob);
          window.open(dataUrl, "_blank");
        }
      }
      else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "The document hasn't been uploaded yet. Please try again later.",
        });
      }
    }
    catch (error) {
      console.error("Error fetching documents:", error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "The document hasn't been uploaded yet. Please try again later.",
      });
    }
    finally {
      setPageLoading(false);
    }


  };


  useEffect(() => {

    const getPageContetsList = async (contentType, language, Type) => {
      try {
        setLoadingTblData(true);
        const res = await pageContentService.GetPageContetListPublic(contentType, language);
        let data = res.data.table.map((item, index) => ({
          key: index + 1,
          contentTypeName: item.contentTypeName,
          contentId: item.contentId,
          title: item.title,

          verificationStatus: item.verificationStatus,
          statusName: item.statusName,
          isActive: item.isActive,
          isActiveName: item.activeName,
          verificationremark: item.verificationRemark,
          publishDate: item.publishDate,
          submitDate: item.submitDate,
          doc: {
            DocUniqueId: item.uniqueId,
            DocMimeType: item.documentMimeType,

          },
        }));

        if (Type === "DownloadPdf") {
          setTblDataDownloadPdf(data)
        }

      } catch (error) {
        setLoadingTblData(false);
      } finally {
        setLoadingTblData(false);
      }
    };

    getPageContetsList(39, lang, "DownloadPdf");

  }, [lang, pageContentService]);


  return (
    <>
      {pageLoading && <Loader />}
      {loadingTblData && <Loader />}
      <BreadcrumbLayout title="Download Pdf" />
      <Container fluid>
        <Row>
          {/* Sidebar */}
          <AboutSidebar menuData={menuData} />
          {/* Content Area */}
          <Col md={9} className="content order-md-last order-first">
            <Row>
              <Col xs={12} className="heading">
               <h3>{t("breadcrumb.annual-report")}</h3>
              </Col>
              <Col xs={12} className="mb-1 mt-1 p-4">

                <Row className="g-4">
                   {/* {loadingTblData && <img src={Animation} alt="Animation gif" />} */}
                  {tblDataDownloadPdf.length > 0 ? (
                    tblDataDownloadPdf.map((row, list) => (
                      <Col md={4} sm={6} xs={12} key={row.key}>
                        <a
                          style={{ textDecoration: "none" }}
                          href="/"
                          onClick={(e) => {
                            e.preventDefault(); // Prevents the default link behavior
                            viewDoc(row.doc);
                          }}
                        >
                          <div className="report-card text-center p-3">


                            <div className="report-thumb mt-2 mb-3">
                              <FilePdfOutlined style={{ fontSize: "60px", color: "#ff4d4f" }} />
                            </div>

                            <h6 className="mb-3">{row.title}</h6>

                            <span className="">
                              <DownloadOutlined /> {lang === 2 ? "View / Download" : "देखें / डाउनलोड"}
                            </span> 


                          </div>
                        </a>

                      </Col>
                    ))
                  ) : (
                    <Col xs={12} className="text-center">
                      <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description={
                          lang === 1
                            ? "वर्तमान में, प्रदर्शित करने के लिए कोई डेटा नहीं है ।"
                            : "Currently, There are no data to display."
                        }
                      />
                    </Col>
                  )}
                </Row>
              </Col>

            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
}

















